require('prismjs/themes/prism-okaidia.css');
